import { service } from '.';

export default {
  getAll: (query) => service.get(`/state_province/all`),
  getAllOpen: (query) => service.get(`/state_province/all/open`),
};
